import { Combobox, type ComboboxProps, useCombobox } from '@sr/ui-library';
import { useState } from 'react';
import { getAllCountryComboboxOptions } from './countryOptions';

type CountryComboboxProps = Omit<
  ComboboxProps,
  'popoverProps' | 'store' | 'trigger'
> & {
  field: { onChange: (v: string) => void; value?: null | string };
};

/**
 * Bare country Combobox — just the shared options list and single-select
 * store wiring. Form chrome (FormItem/FormLabel/FormControl/FormMessage)
 * lives in each field component, matching the pattern used everywhere else.
 * Rest props (id/aria-* injected by FormControl, placeholder, disabled)
 * forward to the trigger button so label association and a11y state work.
 */
export const CountryCombobox = ({ field, ...props }: CountryComboboxProps) => {
  const [open, setOpen] = useState(false);

  const combobox = useCombobox({
    allowDeselect: false,
    isMultiselect: false,
    options: getAllCountryComboboxOptions({
      onSelect: () => setOpen(false),
    }),
    selected: field.value ? [field.value] : [],
    setSelected: (v: string[]) => field.onChange(v[0] ?? ''),
  });

  return (
    <Combobox
      popoverProps={{
        onOpenChange: setOpen,
        open,
      }}
      store={combobox}
      {...props}
    />
  );
};
